import React from 'react';
import twitter2 from './twitter.svg';

const IconTwitter2 = () => (
  <div>
    <img src={twitter2} alt="twitter2" />
  </div>
);
export default IconTwitter2;
